var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FilterBaseSelectBox',{staticClass:"filter-app-launch-form",attrs:{"value":_vm.appLaunchType,"options":_vm.options,"prefix":_vm.prefix,"suffix":_vm.suffix},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }